import { render, staticRenderFns } from "./PeriodeplanSelect.vue?vue&type=template&id=54659e8f"
import script from "./PeriodeplanSelect.ts?vue&type=script&lang=ts&external"
export * from "./PeriodeplanSelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports